'use strict';

(function ($, Drupal, once) {
  Drupal.behaviors.chooseYourRoleBehavior = {
    attach: function attach(context, settings) {
      once('chooseYourRoleBehavior', 'ul.roles', context).forEach(function (element) {
        var menu = $(element);
        var menuWrapper = menu.parent('div');
        var menuTitle = menu.siblings('h4');
        var menuItemLinks = menu.find('a');
        menuTitle.click(function () {
          if (menu.css('display') === 'none') {
            menu.slideDown();
            menuWrapper.addClass('active');
          } else {
            menu.slideUp();
            menuWrapper.removeClass('active');
          }
        });
        $.each(menuItemLinks, function (i, k) {
          var menuItemLink = $(k);
          menuItemLink.click(function (e) {
            e.preventDefault();
            window.location.href = menuItemLink.attr('href');
          });
        });
      });
    }
  };
})(jQuery, Drupal, once);